/**
 * api 接口
 */

const ych = "/ych_h5";

const inbody = "/inbody_h5";

const health_center_service = "/health_center_service";

const api_center_service = "/api_center_service";
const jl = "/bapi";

/*
      '/inbody_h5': {
        target: 'http://test.api.b.yicailife.com',
        changeOrigin: true,
        pathRewrite: {
          '^/inbody_h5/': ''
        }
      },
*/

const userApi = {
	index_city: jl + "/api/cmbc/ffyd/getCitysFromTemplate",
	getVenuesFromTemplate: jl + "/api/cmbc/ffyd/getVenuesFromTemplateV2",
	
	getVenueDetailFromTemplateV2: jl + "/api/cmbc/ffyd/getVenueDetailFromTemplateV2",
  /*
    通用活动
  */
  ych_ans_activity_info: ych + "/activity/activity/info", //活动概览
  ych_ans_activity_userinfo: ych + "/activity/activity/activity_user_info", //活动概览
  ych_ans_activity_ranklist: ych + "/activity/activity/rank_list", //活动排行榜

  ych_ans1_activity_question: ych + "/activity/question/questions", //答题活动当日题目及用户答题情况
  ych_ans1_activity_answer: ych + "/activity/question/answer", //答题活动用户答题

  ych_ans2_activity_upload: ych + "/api/user/upload", //分享美好生活 上传
  ych_ans2_activity_release_share_life: ych + "/activity/share_life/release_share_life", //分享美好生活 发布
  ych_ans2_activity_get_share_life_list: ych + "/activity/share_life/get_share_life_list", //分享美好生活 列表
  ych_ans2_activity_get_like: ych + "/activity/share_life/get_like", //分享美好生活 点赞

  ych_ans3_activity_user_data: ych + "/activity/walking/user_data", //路线活动 用户数据
  ych_ans3_activity_user_exchange: ych + "/activity/walking/exchange", //路线活动 里程兑换
  ych_ans3_activity_route_point: ych + "/activity/walking/points", //路线活动 点位数据

  ych_one_lightning_deals_list: ych + "/api/activity/lightning_deals_list", //ac20231020  1折周星池活动

  /*
    银行活动
  */
  // 交行-河北分行-20230202
  ych_bmc_activity_one_answer: ych + "/activity/bcm_activity/one_answer", //交行-河北分行-20230202
  ych_bmc_activity_two_answer: ych + "/activity/bcm_activity/two_answer", //交行-河北分行-20230202
  ych_bmc_activity_user_info: ych + "/activity/bcm_activity/user_info", //交行-河北分行-20230202
  ych_bcm_activity_send_login_code: ych + "/activity/bcm_activity/send_login_code", //交行-河北分行-20230202
  ych_bcm_activity_login: ych + "/activity/bcm_activity/login", //交行-河北分行-20230202
  ych_bcm_activity_delivery_address: ych + "/activity/bcm_activity/delivery_address", //交行-河北分行-20230202

  // 热橙健康H5
  self_stadiums_list: ych + "/api/fitswim/services", //获取全部酒店列表

  // 安联模拟测试
  test_mock_allianzInLink: ych + "/api/userSource/allianzInLink", //获取全部酒店列表

  // 国寿健康企业列表
  getUserEnterprise: ych + "/api/userSource/projects",

  // 获取验证码
  getCode: ych + "/api/userSource/sendMobileCode",

  // 手机号验证码登录
  mobileLogin: ych + "/api/userSource/mobileLogin",

  // inbody数据
  inbody_getTestList: inbody + "/api/inBody/getTestList",
  getReportList: health_center_service + "/inBody/getReportList",
  getReportDetail: health_center_service + "/inBody/getReportDetail",
  // /inBody/getReportDetail


  // phi[平安健康险]
  phi_couponInfoWithMobile: ych + "/api/phi/couponInfoWithMobile",
  phi_saveCode: ych + "/api/phi/saveCode",
  phi_saveCodeWithoutMobile: ych + "/api/phi/saveCodeWithoutMobile",
  
  // temporary
  api_center_service_jyjz61sign: api_center_service + "/activity/jyjz61sign",
  
  
  
  

};

export default {
  userApi
};



// WEBPACK FOOTER //
// ./src/request/api.js